
import { toast } from "@/hooks/use-toast";
import { AtheismResponse } from "../types";
import { shareViaEmail as baseSocialShareViaEmail, shareViaSMS as baseSocialShareViaSMS, shareToFacebook as baseSocialShareToFacebook } from "@/utils/socialShareUtils";

export const shareViaEmail = (question: string, response: AtheismResponse | null) => {
  if (!response) return;
  
  const subject = `Atheism Defense: ${question}`;
  const body = `
I wanted to share this biblical response to an atheist challenge with you:

Question: ${question}

Direct Answer:
${response.directAnswer}

Biblical Foundation:
${response.biblicalFoundation}

~ Shared from Selah
  `;
  
  baseSocialShareViaEmail(subject, body);
};

export const shareViaSMS = (question: string, response: AtheismResponse | null) => {
  if (!response) return;
  
  const text = `
Atheism Defense: ${question}

Direct Answer:
${response.directAnswer}

~ Shared from Selah
  `;
  
  baseSocialShareViaSMS(text);
};

export const shareToFacebook = () => {
  // Use the base utility function with cache busting
  baseSocialShareToFacebook();
  
  toast({
    title: "Sharing to Facebook",
    description: "A Facebook share dialog should have opened.",
  });
};
